"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardService = void 0;
const tslib_1 = require("tslib");
const _1 = require(".");
class DashboardService {
    constructor() {
        this.__priority = 50;
    }
    getPoleStatusTotals() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rest = _1.Services.Department.rest;
            return ((yield rest.action('collection.total.status.summary', '')).results);
        });
    }
    getPoleStatusSummary() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rest = _1.Services.Department.rest;
            return ((yield rest.action('collection.status.summary', '')).results);
        });
    }
    getPoleLoadingSummary() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rest = _1.Services.Department.rest;
            return ((yield rest.action('collection.loading.summary', '')).results);
        });
    }
}
exports.DashboardService = DashboardService;
//# sourceMappingURL=dashboard.service.js.map